import { STATUS_META } from "@/lib/format";

export function StatusBadge({ status }) {
  const meta = STATUS_META[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${meta.cls}`} data-testid={`status-${status}`}>
      {meta.label}
    </span>
  );
}
